import React from 'react';
import { SvgProps } from './icon.props';

const ThumbDownSvg: React.FC<SvgProps> = ({ color, height, width }) => {
  return (
    <svg
      width={width || 64}
      height={height || 65}
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="32"
        cy="32.695"
        rx="32"
        ry="31.8459"
        fill={color || '#F7F7F7'}
      />
      <g clipPath="url(#clip0_2690_42548)">
        <path
          d="M26.375 48.618C26.7201 48.618 27 48.3395 27 47.996L27 45.1348C27 44.7914 26.7201 44.5128 26.375 44.5128C26.0299 44.5128 25.75 44.7914 25.75 45.1348L25.75 47.996C25.75 48.3395 26.0299 48.618 26.375 48.618Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M40.75 29.2119C41.095 29.2119 41.375 28.9333 41.375 28.5899C41.375 28.2466 41.095 27.9679 40.75 27.9679C40.405 27.9679 40.125 28.2466 40.125 28.5899C40.125 28.9333 40.405 29.2119 40.75 29.2119Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M17.625 30.4559C17.625 31.8277 18.7465 32.9438 20.125 32.9438L24.7908 32.9438C24.0684 34.7851 23.7761 36.9524 23.8324 38.8816C23.8432 39.2498 23.8574 39.4627 23.8766 39.5967C23.9089 40.9406 25.0177 42.0249 26.375 42.0249C27.7535 42.0249 28.875 40.9088 28.875 39.5369L28.875 38.9149C28.875 34.9811 33.9509 32.7709 37.7815 31.8231C38.0711 32.482 38.7323 32.9438 39.5 32.9438L45.75 32.9438C46.0951 32.9438 46.375 32.6653 46.375 32.3219L46.375 17.3941C46.375 17.0506 46.0951 16.7721 45.75 16.7721L39.5 16.7721C38.7374 16.7721 38.0801 17.2278 37.7874 17.8798C37.4703 17.7988 37.1758 17.7223 36.904 17.6516C34.7218 17.0845 33.5198 16.7721 30.5963 16.7721L23.875 16.7721C22.4965 16.7721 21.375 17.8882 21.375 19.2601C21.375 19.7716 21.5311 20.2474 21.7981 20.6432C20.8326 20.9793 20.125 21.8974 20.125 22.992C20.125 23.5017 20.2773 23.979 20.5435 24.3767C19.5823 24.7133 18.875 25.6292 18.875 26.7239C18.875 27.2355 19.0311 27.7113 19.2981 28.1071C18.3326 28.4432 17.625 29.3612 17.625 30.4559ZM38.875 18.6381C38.875 18.2951 39.1554 18.0161 39.5 18.0161L45.125 18.0161L45.125 31.6999L39.5 31.6999C39.1554 31.6999 38.875 31.4208 38.875 31.0779L38.875 18.6381ZM20.125 29.2119C21.4656 29.2119 21.7851 29.2119 23.25 29.2119C23.5951 29.2119 23.875 28.9334 23.875 28.5899C23.875 28.2464 23.5951 27.9679 23.25 27.9679L21.375 27.9679C20.6858 27.9679 20.125 27.4099 20.125 26.7239C20.125 26.0369 20.6846 25.48 21.375 25.48L24.5 25.48C24.8451 25.48 25.125 25.2014 25.125 24.858C25.125 24.5145 24.8451 24.236 24.5 24.236L22.625 24.236C21.9439 24.236 21.375 23.6945 21.375 22.992C21.375 22.3049 21.9346 21.748 22.625 21.748C23.9656 21.748 24.2851 21.748 25.75 21.748C26.0951 21.748 26.375 21.4695 26.375 21.126C26.375 20.7826 26.0951 20.504 25.75 20.504L23.875 20.504C23.1858 20.504 22.625 19.946 22.625 19.2601C22.625 18.5741 23.1858 18.0161 23.875 18.0161L30.5963 18.0161C33.3592 18.0161 34.4383 18.2965 36.5881 18.8553C36.9031 18.9371 37.2485 19.0269 37.625 19.1224L37.625 30.5787C33.102 31.6509 27.625 34.268 27.625 38.9149L27.625 39.5369C27.625 40.2229 27.0643 40.7809 26.375 40.7809C25.687 40.7809 25.1263 40.2237 25.125 39.5389L25.125 39.5369C25.125 39.2666 24.786 35.9491 26.1454 32.9438L28.25 32.9438C28.5951 32.9438 28.875 32.6653 28.875 32.3219C28.875 31.9784 28.5951 31.6999 28.25 31.6999C27.8136 31.6999 20.8374 31.6999 20.125 31.6999C19.4357 31.6999 18.875 31.1418 18.875 30.4559C18.875 29.7688 19.4346 29.2119 20.125 29.2119Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M40.75 26.7239C41.0951 26.7239 41.375 26.4453 41.375 26.1019L41.375 21.126C41.375 20.7825 41.0951 20.504 40.75 20.504C40.4049 20.504 40.125 20.7825 40.125 21.126L40.125 26.1019C40.125 26.4453 40.4049 26.7239 40.75 26.7239Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M31.375 40.7809L33.875 40.7809C34.2201 40.7809 34.5 40.5024 34.5 40.1589C34.5 39.8154 34.2201 39.5369 33.875 39.5369L31.375 39.5369C31.0299 39.5369 30.75 39.8154 30.75 40.1589C30.75 40.5024 31.0299 40.7809 31.375 40.7809Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M18.875 40.7809L21.375 40.7809C21.7201 40.7809 22 40.5024 22 40.1589C22 39.8154 21.7201 39.5369 21.375 39.5369L18.875 39.5369C18.5299 39.5369 18.25 39.8154 18.25 40.1589C18.25 40.5024 18.5299 40.7809 18.875 40.7809Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M20.6299 45.8764C20.8741 46.1192 21.2697 46.1192 21.5139 45.8764L23.2813 44.1174C23.5254 43.8745 23.5254 43.4807 23.2813 43.2377C23.0371 42.9949 22.6416 42.9949 22.3974 43.2377L20.6299 44.9967C20.3859 45.2396 20.3859 45.6334 20.6299 45.8764Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M29.4693 44.1174L31.2367 45.8764C31.4809 46.1192 31.8765 46.1192 32.1207 45.8764C32.3647 45.6335 32.3647 45.2396 32.1207 44.9967L30.3532 43.2377C30.109 42.9949 29.7134 42.9949 29.4693 43.2377C29.2252 43.4806 29.2252 43.8745 29.4693 44.1174Z"
          fill={color || '#1F1F1F'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2690_42548">
          <rect
            width="32"
            height="31.8459"
            fill="white"
            transform="translate(48 48.618) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ThumbDownSvg;
